const OrderStatusDisplayType = {
  RECEIVED: 1,
  SHIPPED: 2,
  DELIVERED: 3,
  PARTIAL: 4,
  CANCELLED: 5,
  UNKNOWN: 6,
  COMPLETED: 7,
  HOLD: 8,
};

export default OrderStatusDisplayType;
